<template>
	<v-dialog v-model="isDialogShow" persistent max-width="600">
		<v-card>
			<v-card-text class="text-center">
				<div class="pt-3 d-flex justify-center">
					<v-col cols="6">
						<v-img src="/assets/icon/confirm-vo.svg"></v-img>
					</v-col>
				</div>
				<div>
					<div class="d-block" v-html="msg"></div>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-row class="mb-2">
					<!-- <v-col cols="12" sm="12" md="6">
						<v-btn color="primary" outlined block class="text-capitalize cl-primary my-1" @click="gotoAction(type)">{{ (type === 'pramitra') ? 'Lihat Prospek Mitra' : 'Lihat Genealogy Mitra' }}</v-btn>
					</v-col> -->
					<v-col cols="12" sm="12" md="12" class="d-flex justify-center">
						<v-btn color="grey darken-1" outlined class="text-capitalize my-1" @click.stop="gotoAction(type)">{{ closeText }}</v-btn>
					</v-col>
				</v-row>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	data () {
		return {
			isDialogShow: false,
			closeText: 'Tutup',
		}
	},
	props: {
		msg: String,
		msgTwo: String,
		type: String,
	},
	computed: {
	},
	methods: {
		...mapActions('auth', ['logout']),

		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		confirm() {
			this.$emit('action')
		},
		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			})
		},
		gotoAction(type) {
			this.modalHide()
			if(type === 'pramitra') this.onLogout()
			else if(type === 'mitra') this.$router.push({name: 'genealogy'})
		}
	}
};
</script>